import { message, Pagination, Rate } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

const AdminEmployessDetail = () => {
  const params = useParams();
  const employessId = params.id;
  const [data, setData] = useState([]);
  const [averageRating, setAverageRating] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);

  const apiUrl = process.env.REACT_APP_API_URL;
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

  const handleDeleteReview = async (reviewId) => {
    try {
      const response = await fetch(`${apiUrl}/api/employess/${employessId}/reviews/${reviewId}`, {
        method: "DELETE",
      });

      if (response.ok) {
        message.success("Yorum silindi");
        setData(prevData => ({
          ...prevData,
          reviews: prevData.reviews.filter(review => review.id !== reviewId),
        }));
      } else {
        message.error("Yorum silinemedi");
      }
    } catch (error) {
      console.log(error);
      message.error("Sunucu hatası");
    }
  };

  useEffect(() => {
    const fetchSingleEmployess = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/employess/${employessId}`);
        if (response.ok) {
          const data1 = await response.json();
          const imgSrc = data1.img?.startsWith("http")
            ? data1.img
            : `${imageBaseUrl}/${data1.img}`;

          setData({ ...data1, img: imgSrc });
          const avgRating = calculateAverageRating(data1.reviews);
          setAverageRating(avgRating);
        } else {
          message.error("Çalışan verileri getirilemedi");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSingleEmployess();
  }, [apiUrl, employessId, imageBaseUrl]);

  const calculateAverageRating = (reviews) => {
    if (!reviews || reviews.length === 0) return 0;
    const totalRating = reviews.reduce((acc, review) => acc + review.rating, 0);
    return totalRating / reviews.length;
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const paginatedReviews = data.reviews?.slice((currentPage - 1) * pageSize, currentPage * pageSize) || [];

  if (averageRating === null) {
    return <div>Yükleniyor...</div>;
  }

  return (
    <div className="admin-page-employess-detail">
      <div className="admin-employess-detail-img" style={{
        display: "flex",
        justifyContent: "center",
        gap: "30px",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: "30px",
        textAlign: "center",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
      }}>
        <img src={data.img} alt="" style={{
          width: "150px",
          height: "150px",
          borderRadius: "50%",
          objectFit: "cover",
          border: "3px solid #ddd",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"
        }} />
        <b style={{ fontSize: "1.2em", fontWeight: "bold", marginTop: "10px", color: "#333" }}>{data.name}</b>
        <div style={{ marginTop: "15px", fontSize: "1.2em", color: "#333" }}>
          <Rate disabled defaultValue={averageRating} />
          <span style={{ marginLeft: "10px", fontSize: "1em", color: "#555" }}>{averageRating.toFixed(1)} / 5</span>
        </div>
      </div>
      <div className="reviews-section" style={{
        marginTop: "30px",
        padding: "20px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
      }}>
        <h3 style={{ fontSize: "1.5em", color: "#333", marginBottom: "20px" }}>Çalışan Yorumları</h3>
        {paginatedReviews.length > 0 ? (
          paginatedReviews.map((review) => (
            <div key={review.id} style={{
              display: "flex",
              position: "relative",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "20px",
              padding: "15px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f4f4f4",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)"
            }}>
              <div>
                <div style={{ fontSize: "1.1em", fontWeight: "bold", color: "#333" }}>{review.name}</div>
                <div style={{ fontSize: "1em", color: "#555", margin: "10px 0" }}>{review.text}</div>
                <Rate disabled defaultValue={review.rating} />
                <small>{new Date(review.createdAt).toLocaleString()}</small>
                <div style={{ fontSize: "1em", color: "#555", marginTop: "10px" }}>
                  <b>Telefon:</b> {review.phoneNumber ? review.phoneNumber : "Belirtilmemiş"}
                </div>
              </div>

              <button onClick={() => handleDeleteReview(review.id)} style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                position: "absolute",
                top: "10px",
                right: "10px",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                fontSize: "16px",
                cursor: "pointer"
              }}>X</button>
            </div>
          ))
        ) : (
          <p style={{ fontSize: "1.1em", color: "#888" }}>Henüz yorum yapılmamış.</p>
        )}
      </div>
      <br />
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        align='center'
        total={data.reviews?.length || 0}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default AdminEmployessDetail;
